import Message from "../../message";
import {useMainStore} from "@/store";
import router from "@/router";

export default class Banned extends Message
{
    handle()
    {
        useMainStore().SET_BAN(this.message.ban);
        router.push({name: 'banned'}).then(() => {});
    }
}